import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import Container from '@/components/Atoms/Container'
import Loading from '@/components/Atoms/Loading'
import { HasFeature } from '@/components/Atoms/Permissions'
import { ApplicationsFeature } from '@/lib/features/applications'
import { buildPath } from '@/routes'
import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router'

export function ApplicationsLayout() {
  return (
    <HasFeature
      feature={ApplicationsFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Container className="mt-2 flex flex-col gap-4">
        <Breadcrumb label="Applications" path={buildPath('/applications')} />

        <Suspense
          fallback={<Loading variant="fullscreen" className="min-h-64" />}
        >
          <Outlet />
        </Suspense>
      </Container>
    </HasFeature>
  )
}
